import { createI18n } from 'vue-i18n'
import zh from './config/zh'
import en from './config/en'

// 注意：这里不再需要合并 Element Plus 的语言包
// 因为我们已经在 main.js 中单独配置了 Element Plus 的 locale
const messages = {
  zh: {
    ...zh
  },
  en: {
    ...en
  }
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem('locale') || 'zh',
  fallbackLocale: 'zh',
  messages
})

export default i18n